import { useState } from "react";

const useFormValidation = (form) => {
  const [formValid, setFormValid] = useState(false);
  const [formValues, setFormValues] = useState({});
  const handleValuesChange = (changedValues, allValues) => {
    const fieldName = Object.keys(changedValues);
    const allVals = Object.entries(allValues);
    setFormValues(allValues);
    form
      .validateFields(fieldName)
      .then(() => {
        let flag = false;
        allVals.forEach((i) => {
          i.forEach((elem, index) => {
            if (index == 1) {
              if (elem || (typeof elem === "boolean" && elem)) {
                flag = true;
              } else {
                flag = false;
              }
            }
          });
        });
        setFormValid(flag);
      })
      .catch((err) => {
        if (err.errorFields?.length === 0) {
          setFormValid(true);
        } else {
          setFormValid(false); // Set formValid to false if any field is invalid
        }
      });
  };

  return { formValid, handleValuesChange, formValues, setFormValues };
};

export default useFormValidation;
